import { useTranslation } from "src/hooks";
import { TableColumnKey } from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";
import { AddWalletBalanceMonitorFields, initAddressBookFields } from "../../..";
import { Dispatch, SetStateAction } from "react";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import { Box } from "src/components/MuiGenerals";
import WalletAddressTextField from "./components/WalletAddressTextField";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function WalletFieldSection({
  fields,
  setFields,
}: {
  fields: AddWalletBalanceMonitorFields;
  setFields: Dispatch<SetStateAction<AddWalletBalanceMonitorFields>>;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const array = [
    {
      label: t(TableColumnKey.ChainName),
      component: (
        <ChainNameSingleSelection
          value={fields.chainName}
          onChange={(chainName) =>
            setFields((prev) => ({
              ...prev,
              chainName,
              currency: "",
              addressBookFields: initAddressBookFields,
            }))
          }
        />
      ),
    },
    {
      label: t(TableColumnKey.Currency),
      component: (
        <CurrencySingleSelection
          value={fields.currency}
          onChange={(currency) => setFields((prev) => ({ ...prev, currency }))}
          chainName={fields.chainName}
        />
      ),
    },
    {
      label: t(TableColumnKey.WalletAddress),
      component: (
        <WalletAddressTextField
          chainName={fields.chainName}
          addressBookFields={fields.addressBookFields}
          onChange={(key, value) =>
            setFields((prev) => ({
              ...prev,
              addressBookFields: { ...prev.addressBookFields, [key]: value },
            }))
          }
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "20px",
        rowGap: "28px",
        "& .MuiFormControl-root": {
          flex: 1,
        },
      }}
    >
      {array.map((item, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "0.3fr 1fr",
            gap: "8px",
            fontSize: "12px",
            alignItems: "end",
          }}
        >
          <div style={{ lineHeight: "2rem" }}>{item.label}</div>
          {item.component}
        </div>
      ))}
    </Box>
  );
}

export default WalletFieldSection;
